import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { KeyValueListModule } from '../../../projects/kiene-core/src/lib/components/key-value-list/key-value-list.module';
import { PageLayoutModule } from '../../../projects/kiene-core/src/lib/components/page-layout/page-layout.module';
import { DirectivesModule } from '../../../projects/kiene-core/src/lib/directives/directives.module';
import { KieneAutocompleteModule } from '../components/kiene-autocomplete/kiene-autocomplete.module';
import { KieneTableModule } from '../components/kiene-table/kiene-table.module';
import { BugReportButtonComponent } from './bug-report-button/bug-report-button.component';
import { PrioritaetenDialogComponent } from './prioritaeten-dialog/prioritaeten-dialog.component';
import { TicketDetailsComponent } from './ticket-details/ticket-details.component';
import { TicketStatushistorieComponent } from './ticket-details/ticket-statushistorie/ticket-statushistorie.component';
import { TicketUebersichtHistorieComponent } from './ticket-uebersicht/ticket-uebersicht-historie/ticket-uebersicht-historie.component';
import { TicketUebersichtOffeneComponent } from './ticket-uebersicht/ticket-uebersicht-offene/ticket-uebersicht-offene.component';
import { TicketUebersichtComponent } from './ticket-uebersicht/ticket-uebersicht.component';
import { TicketsystemRoutingModule } from './ticketsystem-routing.module';
import { TabinfoModule } from '../components/tabinfo/tabinfo.module';
import { TicketTypeDialogComponent } from './ticket-type-dialog/ticket-type-dialog.component';

@NgModule({
    declarations: [
        BugReportButtonComponent,
        TicketDetailsComponent,
        PrioritaetenDialogComponent,
        TicketStatushistorieComponent,
        TicketUebersichtComponent,
        TicketUebersichtHistorieComponent,
        TicketUebersichtOffeneComponent,
        TicketTypeDialogComponent,
    ],
    imports: [
        CommonModule,
        TicketsystemRoutingModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        RouterModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        KieneTableModule,
        MatSelectModule,
        MatTabsModule,
        MatMenuModule,
        MatTooltipModule,
        KeyValueListModule,
        DirectivesModule,
        MatDividerModule,
        MatSlideToggleModule,
        MatListModule,
        PageLayoutModule,
        KieneAutocompleteModule,
        MatProgressBarModule,
        MatBadgeModule,
        TabinfoModule,
    ],
    exports: [BugReportButtonComponent],
})
export class TicketsystemModule {}
